import { createClient } from '@supabase/supabase-js';
const supabaseUrl = 'https://zrajztzymhcaborfbtnw.supabase.co';
const supabaseKey = 'sb_publishable_HnuTkl3m_sIK0DQwTvLdBg_39OGFgFa';
export const supabase = createClient(supabaseUrl, supabaseKey);
